/**
 *
 * Asynchronously loads the component for FPLSearchResult
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { PageLoading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "FPLSearchResult" */),
  loading: <PageLoading />
})
